<app-nav (emitLang)="reciever($event)" [lang]="languageCode"></app-nav>
<!-- @if (consent === null){
<app-cookie-consent-dialog
  (emitLang)="reciever($event)"
  [lang]="languageCode"
  disableClose:true
  style="display: flex; position: absolute; min-width: 100vw; height: 100vh"
/>
} -->
<router-outlet (activate)="onActive()" />
<app-footer />
